import {
  ACCESS_DENIED,
  GLOBAL_SEARCH,
  INITIAL_DATA,
  LEARN_MORE,
  LOGGED_OUT,
  PRODUCT_SUBSCRIBE,
  PRODUCT_SUBSCRIBE_DETAILS,
  PRODUCT_VERIFY_TOKEN,
} from 'actions/types'
import {clearStorage} from 'utils/local-storage'

export default function (state = {}, action) {
  switch (action.type) {
    case 'LOGGED_IN':
      return {...state, isLoggedOut: false}
    case LOGGED_OUT:
      return {isLoggedOut: true, tokenExpired: false}
    case ACCESS_DENIED: {
      clearStorage()
      return {...state, tokenExpired: true}
    }
    case GLOBAL_SEARCH:
      return {
        ...state,
        globalSearchData: action.payload || {},
      }

    case PRODUCT_SUBSCRIBE:
      return {
        ...state,
        productSubData: action.payload || {},
      }

    case PRODUCT_SUBSCRIBE_DETAILS:
      return {
        ...state,
        productSubDetails: action.payload || [],
      }

    case PRODUCT_VERIFY_TOKEN: {
      return {...state, tokenData: action.payload || {}}
    }

    case LEARN_MORE:
      return {
        ...state,
        learnMoreData: action.payload || {},
      }

    case INITIAL_DATA:
      return {...state, initialData: action.payload || {}}

    default:
      return state
  }
}
